import { loadOnce } from '../../app/chunks'
import type { Lightbox } from './Lightbox'

/** The photo viewer is a chunk of its own, fetched the first time a photo is opened. */
export const photoViewerSource = {
  load: (): Promise<typeof Lightbox> => import('./Lightbox').then((module) => module.Lightbox),
}

/** Loads the photo viewer once. After a failure (offline, or an update replaced the chunk) the next photo tries again. */
export const loadPhotoViewer = loadOnce(photoViewerSource)
